import { FC } from 'react';
import { Checkbox } from 'antd';

type Props = {
  label?: string;
  isChecked?: boolean;
};

export const CheckboxDisabledMode: FC<Props> = ({ label, isChecked }) => {
  return (
    <Checkbox className="ss-checkbox" checked={isChecked} disabled>
      {label}
    </Checkbox>
  );
};
